import { UseMutationOptions } from 'react-query';

import { UpdateSocialConnectionMutation, UpdateSocialConnectionMutationVariables } from 'api';
import { useNotify, useSocialConnections } from 'hooks';

type Mutation = UpdateSocialConnectionMutation;
type MutationVariables = UpdateSocialConnectionMutationVariables;

const useUpdateSocialConnection = () => {
  const { socialAccounts, setSocialAccounts } = useSocialConnections();
  const notify = useNotify();

  const mutationOptions: UseMutationOptions<Mutation, unknown, MutationVariables> = {
    onMutate: ({ input: { token_id, smart_schedule } }) => {
      const newSocialAccounts = socialAccounts.map(item =>
        item.id == token_id ? { ...item, smart_schedule: !smart_schedule } : item
      );
      setSocialAccounts(newSocialAccounts);
    },
    onError: () => {
      notify.mutationError();
    },
  };

  return mutationOptions;
};

export default useUpdateSocialConnection;
